import * as React from 'react';
import {CSSProperties} from 'react';
import * as Tgcc from '../tgccGlobal';
import {connect} from 'react-redux';
import Radium, { StyleRoot } from 'radium';


const followHdr: React.CSSProperties = {
    fontSize:'40px',
    fontFamily:'Lulo',
    color:'#3A54B4',
    marginBottom:'10px',
    marginTop:'50px'
}
const container: React.CSSProperties = {
    display:'flex',
    flexDirection:'column',
    justifyContent:'center',
    alignItems:'center'
}
const socialDiv: React.CSSProperties = {
    display:'flex',
    flexDirection:'row'
}
const followDiv: React.CSSProperties = {
    display:'flex',
    flexDirection:'column',
    alignItems:'center'
}
const socialImg: React.CSSProperties = {
    width:'286px',
    marginRight:'50px'
}
const socialImg1 = Object.assign({},socialImg,{marginRight:'unset'})
const p: React.CSSProperties = {
    color:'#3A54B4'
}
const gcInsta: React.CSSProperties = {
    ':hover':{
        textDecoration:'underline'
    }
}
class _CampusCustomerContent extends React.Component<Tgcc.BaseProps, any> {  

    render() {      
        return (
                <div style={container}>
                    <div style={followDiv}>
                        <div style={followHdr}>FOLLOW US</div>
                        <p style={p}><a href="https://instagram.com/thegraphiccow_campus" style={gcInsta}>&#64;graphiccow_campus</a></p>
                    </div>
                    <div style={socialDiv} className="socDiv">
                        <img style={socialImg} className="socImg" src={Tgcc.ResolveUrl('~/images/Social_1.png')} />
                        <img style={socialImg} className="socImg" src={Tgcc.ResolveUrl('~/images/Social_2.png')} />
                        <img style={socialImg} className="socImg" src={Tgcc.ResolveUrl('~/images/Social_3.png')} />
                        <img style={socialImg1} className="socImg" src={Tgcc.ResolveUrl('~/images/Social_4.png')} />
                    </div>               
                </div>  
        )
    }
}
const mapStateToProps = (state : Tgcc.GlobalState, ownState: any) => {
    return { state: state };
};

export var CampusCustomerContent = connect(mapStateToProps)(Radium(_CampusCustomerContent));
